module.exports = __webpack_public_path__ + "img/external-link.9115eec5.svg";